// extracted by mini-css-extract-plugin
export default {"loadingTyre":"style_loadingTyre__c-9KP","tyre-spin":"style_tyre-spin__bAAt0","loadingContainer":"style_loadingContainer__mAQDA"};